export * from './acesso-oferta-educacional-state/acesso-oferta-educacional-state.service';
export * from './anos-referencias/anos-referencias.service';
export * from './autenticacao/autenticacao.service';
export * from './caq-request/caq-request.service';
export * from './condicao-qualidade-state/condicao-qualidade-state.service';
export * from './dado-financeiro/dado-financeiro.service'
export * from './dado-indice-desenvolvimento-humano/dado-indice-desenvolvimento-humano.service';
export * from './dado-socioeconomico/dado-socioeconomico.service';
export * from './dados-estatisticos/dados-estatisticos.service';
export * from './diagnostico-matricula/diagnostico-matricula.service';
export * from './etapas-de-edicao/etapas-de-edicao.service';
export * from './funcionarios-por-area-atuacao/funcionarios-por-area-atuacao.service';
export * from './informacoes-educacionais/informaco-educacionais.service';
export * from './localizacao/localizacao.service';
export * from './matriculas-por-escola/matriculas-por-escola.service';
export * from './memoria-de-calculo/memoria-de-calculo.service';
export * from './pqr-adicionais/pqr-adicionais.service';
export * from './preco-encargos-adicionais-state/preco-encargos-adicionais-state.service';
export * from './pqr-alimentacao-escolar/pqr-alimentacao-escolar.service';
export * from './pqr-carga-horaria-ensino/pqr-carga-horario-ensino.service';
export * from './pqr-carreira-remuneracao-professores/pqr-formacao-jornada-remuneracao-professores.service';
export * from './pqr-encargos-sociais/pqr-encargos-sociais.service';
export * from './pqr-multiplicador-anual/pqr-multiplicador-anual.service';
export * from './pqr-fator-ponderacao/pqr-fator-ponderacao.service';
export * from './pqr-infraestrutura-predios-escolares/pqr-infraestrutura-predios-escolares.service';
export * from './pqr-manutencao-formacao-material/pqr-manutencao-formacao-material.service';
export * from './pqr-novas-salas-predios/pqr-novas-salas-predios.service';
export * from './pqr-numeros-dias-letivos/pqr-numeros-dias-letivos.service';
export * from './pqr-quadro-funcionario-remuneracao/pqr-quadro-funcionarios-remuneracao.service';
export * from './pqr-tamanho-minimo-turma/pqr-tamanho-minimo-turma.service';
export * from './pqr-tamanho-turmas/pqr-tamanho-turmas.service';
export * from './tipos-etapas-modalidade-serie/tipos-etapas-modalidade-serie.service';
export * from './relatorio-caq/relatorio-caq.service';
export * from './novas-salas-edicao-csv/novas-salas-edicao-csv.service';
